import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';

type GameRulesVersion = {
  id: string;
  title: string;
  version?: string;
  type: string;
  rules_text: string;
  is_default: boolean;
  status: string;
  created_at: string;
  updated_at: string;
};

type GetGameRulesVersionsResponse = {
  rules_versions: GameRulesVersion[];
};

export const getGameRulesVersions = (type?: string): Promise<GetGameRulesVersionsResponse> =>
  apiClient.get(
    `/api/admin/squares/game-rules${type ? `?type=${type}` : ''}` as any
  ) as Promise<GetGameRulesVersionsResponse>;

export const useGetGameRulesVersionsQuery = (type?: string) => {
  return useQuery({
    queryKey: ['game-rules', 'versions', type],
    queryFn: () => getGameRulesVersions(type),
  });
};

// Backwards-compatible aliases
export const getSquaresGameRulesVersions = () => getGameRulesVersions('squares');
export const useGetSquaresGameRulesVersionsQuery = () => useGetGameRulesVersionsQuery('squares');
